import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableDeliveryNotes',
  initialState: false,
  reducers: {
    setEnableDeliveryNotes(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableDeliveryNotes } = slice.actions;

export default slice.reducer;
